import { MeetingType } from '@commenda/prisma';
import { IMeeting } from '@commenda/types/src/meeting/types';
import { SWRFetcher } from '@commenda/utils';
import useSWR, { KeyedMutator } from 'swr';

export const MEETING_NAME_MAPPING = {
  [MeetingType.COMPLIANCE_CONSULTATION]: 'Compliance Consultation',
  [MeetingType.REVIEW_COMPLIANCE_CALENDAR]: 'Review Compliance Calendar',
  [MeetingType.SERVICES_MARKETPLACE_INTRO_CALL]:
    'Services Marketplace Intro Call',
  [MeetingType.UNKNOWN]: 'General Meeting',
};

export function useMeetings({
  corporationId,
  userId,
}: {
  corporationId?: number;
  userId?: string;
}) {
  const query = new URLSearchParams();
  if (corporationId) {
    query.append('corporationId', corporationId.toString());
  }
  if (userId) {
    query.append('userId', userId.toString());
  }

  const {
    data,
    error,
    mutate,
  }: {
    data?: IMeeting[];
    error?: unknown;
    mutate: KeyedMutator<unknown>;
  } = useSWR(
    !corporationId && !userId ? null : `meeting?${query}`,
    SWRFetcher({
      method: 'GET',
    })
  );

  return {
    data,
    error,
    mutate,
  };
}
